import React from 'react'
import PropTypes from 'prop-types'
import { makeT, sharedT } from '../../../../group_leader/helpers/i18n'
import { buildSlots, formatHandicap, playerFullName, playerInitials } from '../../../../group_leader/helpers/player'

const t = makeT('group_leader.event_setup.pairings')

// One pairing as a card on a phone; seats past the group size are not drawn.
const PairingsMobileCard = ({
  group, slotCount, maxSize, hasBenchGolfers, onDelete, deleting, onOpenEmptySlot, onOpenSlotMenu,
}) => {
  const attrs = group.attributes || {}
  const slots = buildSlots(attrs.players || [], attrs.blinds || [], slotCount)

  return (
        <div className="gl-event-setup-mc-card">
          <div className="gl-event-setup-mc-hd">
            <span className="gl-event-setup-mc-hole">
              {t('mobile_card.hole_label', { name: `${attrs.hole || attrs.tee_number || 1}${attrs.hole_letter || ''}` })}
            </span>
            <span className="gl-event-setup-mc-time">{attrs.tee_time || '-'}</span>
            <button
              className="gl-event-setup-mc-del-btn"
              type="button"
              aria-label={t('sheet.delete_group_aria')}
              onClick={() => onDelete(group.id, (attrs.players || []).length)}
              disabled={deleting}
            >
              &times;
            </button>
          </div>
          {slots.map((player, slotIndex) => {
            if (!player) {
              if (slotIndex >= maxSize) { return null }
              return (
                <button
                  key={`empty-${slotIndex}`}
                  type="button"
                  className="gl-event-setup-mc-empty-slot"
                  onClick={(event) => onOpenEmptySlot(event, group.id, slotIndex)}
                >
                  {hasBenchGolfers ? t('slot_menu.add_golfer') : t('mobile_card.empty_slot')}
                </button>
              )
            }
            const isBlind = player._type === 'blind'
            const name = playerFullName(player)
            const handicap = formatHandicap(player.handicap_index)
            return (
              <button
                key={player.player_round_id}
                className="gl-event-setup-mc-slot"
                type="button"
                onClick={(event) => onOpenSlotMenu(event, group.id, slotIndex, player)}
              >
                <div
                  className={isBlind ? 'gl-event-setup-blind-av' : 'gl-player-av'}
                  aria-hidden="true"
                >
                  {playerInitials(player)}
                </div>
                <div className="gl-event-setup-mc-slot-info">
                  <div className="gl-player-nm">{isBlind ? `[${name}]` : name}</div>
                  {handicap !== null && (
                    <div className="gl-event-setup-mc-slot-hi">
                      {sharedT('hi_display', { value: handicap })}
                    </div>
                  )}
                </div>
                <span className="gl-event-setup-mc-slot-chevron" aria-hidden="true">&#8250;</span>
              </button>
            )
          })}
        </div>
  )
}

PairingsMobileCard.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
    attributes: PropTypes.object,
  }).isRequired,
  // The widest row on the sheet, which can exceed the group size.
  slotCount: PropTypes.number.isRequired,
  // The configured group size: an empty seat beyond it is not offered.
  maxSize: PropTypes.number.isRequired,
  // Changes an empty seat's label from "no golfer" to "add golfer" -- there is somebody to add.
  hasBenchGolfers: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  deleting: PropTypes.bool,
  onOpenEmptySlot: PropTypes.func.isRequired,
  onOpenSlotMenu: PropTypes.func.isRequired,
}

export default PairingsMobileCard
